<template>
  <div class="personal">
    <div class="personal-box">
      <Nav />
      <div v-if="isShow" class="search-content">
        <div class="search-header">请选择身份验证方式</div>
        <div class="search-content-detail">
          <div class="search-content-detail-left" @click="toHandleSearch">
            <div class="search-content-detail-img">
              <img src="../../../assets/img/u1137.png" />
            </div>
            <div class="search-content-detail-title">手动输入证件</div>
          </div>
          <div class="search-content-detail-right" @click="toAutomaticSearch">
            <div class="search-content-detail-img">
              <img src="../../../assets/img/u1141.png" />
            </div>
            <div class="search-content-detail-title">自动识别证件</div>
          </div>
        </div>
      </div>
      <div v-else class="bbbbbbbbbbbbbb">
        <div class="personal-content" v-if="verifyIdShow">
          <div v-if="isFlag">
            <div class="personal-header">操作此栏目内容，请先验证身份</div>
            <div class="personal-content-box">
              <div class="personal-content-left">
                <div class="personal-content-img">
                  <img src="../../../assets/img/personal-search.png" />
                </div>
              </div>
              <div class="personal-content-right">
                <div class="personal-content-btn" @click="toAutomatic">切换为自动识别</div>
                <div class="personal-content-title">请输入您的证件号码</div>
                <div class="personal-content-input">
                  <el-input v-model="input" clearable style="width: 100%;"></el-input>
                </div>
                <div class="personal-content-keyBox">
                  <div class="personal-content-top">
                    <div class="personal-content-one" @click="toAdd(7)">7</div>
                    <div class="personal-content-one" @click="toAdd(8)">8</div>
                    <div class="personal-content-one" @click="toAdd(9)">9</div>
                    <div class="personal-content-one" @click="deleteItem">
                      <img src="../../../assets/img/delete.png" />
                    </div>
                    <div class="personal-content-one" @click="toAdd(4)">4</div>
                    <div class="personal-content-one" @click="toAdd(5)">5</div>
                    <div class="personal-content-one" @click="toAdd(6)">6</div>
                    <div class="personal-content-one" @click="clearItem">清空</div>
                  </div>
                  <div class="personal-content-bottom">
                    <div class="content-bottom-left">
                      <div class="bottom-left-top">
                        <div class="personal-content-one" @click="toAdd(1)">1</div>
                        <div class="personal-content-one" @click="toAdd(2)">2</div>
                        <div class="personal-content-one" @click="toAdd(3)">3</div>
                      </div>
                      <div class="bottom-left-bottom">
                        <div class="personal-content-zero" @click="toAdd(0)">0</div>
                        <div class="personal-content-x" @click="toAdd('X')">X</div>
                      </div>
                    </div>
                    <div class="content-bottom-right">
                      <div class="bottom-right-one" @click="toSearch">确认</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="aaaaaaaaaaaaaaaaaa">
            <div class="personal-header" style="background-color: #ffffff;color: #ffffff;">操作此栏目内容，请先验证身份</div>
            <div class="personal-content-box">
              <div class="personal-content-left">
                <div class="personal-content-img">
                  <img src="../../../assets/img/personal-search.png" />
                </div>
              </div>
              <div class="personal-content-right">
                <div class="personal-content-btn" @click="toHandle">切换为手动输入</div>
                <div class="personal-content-title">请放入您的证件，系统将自动识别</div>
                <div class="personal-content-input">
                  <el-input v-model="input" clearable style="width: 100%;"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="phone-check-content">
          <div class="phone-check-box">
            <div class="phone-check-detail" v-if="verificationCodeShow">
              <div class="phone-check-one">请输入您的手机号码</div>
              <div>
                <el-input v-model="phone" clearable style="width: 100%;"></el-input>
              </div>
              <div class="phone-check-btn">
                <div class="phone-btn-left" @click="toPrevious">上一步</div>
                <div class="phone-btn-right ml-8" @click="toVerification">验证</div>
              </div>
            </div>
            <div class="phone-check-verification" v-else>
              <div class="phone-verification-code">
                <div class="verification-code-text">验证码</div>
                <div class="verification-code-phone">
                  <span>已发送至</span>
                  <span>{{this.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}}</span>
                </div>
                <div class="phone-input-list display">
                  <div>
                    <numInput v-model="mesVal"></numInput>
                    <!-- <el-input v-model="codeForm.code1" style="width:50px;height:50px" maxlength="1"></el-input>
                  <el-input v-model="codeForm.code2" style="width:50px;height:50px" maxlength="1"></el-input>
                  <el-input v-model="codeForm.code3" style="width:50px;height:50px" maxlength="1"></el-input>
                    <el-input v-model="codeForm.code4" style="width:50px;height:50px" maxlength="1"></el-input>-->
                  </div>
                  <div class="send-again">
                    <el-button :disabled="disabled" @click="sendcode" class="sendcode">{{btntxt}}</el-button>
                  </div>
                </div>
                <div class="make-determine">
                  <div class="make-determine-btn" @click="toCheckCode">确定</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from '@/components/nav.vue';
import numInput from '@/components/num-input.vue';
import {
  queryHouseholdIndex,
  loginHouseholdIndex,
  verifyCodeLogin
} from '@/api/publicinquiry.api.js';
import { setSession, getSession } from '@/untils';
export default {
  components: {
    Nav,
    numInput
  },
  props: {
    pageType: {
      type: Number | String,
      default: 1
    }
  },
  data() {
    return {
      input: '',
      projectId: '',
      verifyIdShow: true,
      phone: '',
      verificationCodeShow: true,
      time: 60,
      btntxt: '',
      isSmsVerify: '',
      codeForm: {
        code1: '',
        code2: '',
        code3: '',
        code4: ''
      },
      verifyCode: '',
      mesVal: null,
      timeDate: null,
      isShow: true,
      isFlag: true
    };
  },
  methods: {
    goBack() { },
    toAdd(item) {
      this.input += item;
    },
    deleteItem() {
      this.input = this.input.substring(0, this.input.length - 1);
    },
    clearItem() {
      this.input = '';
    },
    toSearch() {
      if (this.input != '') {
        if (this.isSmsVerify == 0) {
          let params = {
            certificateNumber: this.input,
            projectId: this.projectId
          };
          loginHouseholdIndex(params).then(res => {
            if (res.code === 0) {
              switch (+this.pageType) {
                case 1:
                  this.$router.push({ name: 'personaldetail' });
                  break;
                case 2:
                  this.$router.push({ name: 'selectionDetail' });
                  break;
                default:
                  console.warn('组件入参错误');
                  break;
              }
              setSession('userInfo', res.body);
            } else {
              this.$message({
                message: res.errMsg,
                type: 'warning'
              });
            }
          });
        } else {
          this.verifyIdShow = false;
        }
      } else {
        this.$message({
          message: '证件号码不能为空',
          type: 'warning'
        });
      }
    },
    toPrevious() {
      this.verifyIdShow = true;
    },
    toVerification() {
      this.time = 60;
      this.timer();
      let params = {
        certificateNumber: this.input,
        phone: this.phone,
        projectId: this.projectId
      };
      loginHouseholdIndex(params).then(res => {
        if (res.code === 0) {
          this.verificationCodeShow = false;
        } else {
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    },
    //发送手机验证码倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        this.time--;
        this.btntxt = `重新获取${this.time}s`;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = '重新获取';
        this.disabled = false;
      }
    },
    sendcode() {
      this.time = 60;
      this.timer();
      let params = {
        certificateNumber: this.input,
        phone: this.phone,
        projectId: this.projectId
      };
      loginHouseholdIndex(params).then(res => {
        if (res.code === 0) {
          this.verificationCodeShow = false;
        } else {
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    },
    toCheckCode() {
      let params = {
        certificateNumber: this.input,
        phone: this.phone,
        verifyCode: this.mesVal,
        projectId: this.projectId
      };
      verifyCodeLogin(params).then(res => {
        if (res.code === 0) {
          switch (+this.pageType) {
            case 1:
              this.$router.push({ name: 'personaldetail' });
              break;
            case 2:
              this.$router.push({ name: 'selectionDetail' });
              break;
            default:
              console.warn('组件入参错误');
              break;
          }
        } else {
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    },
    connect() {
      // const origin = location.protocol + '//' + location.host;
      // const BASE_API = String.prototype.replace.call(
      //   process.env.BASE_API,
      //   /#/,
      //   origin
      // );
      let WS_API = `http://127.0.0.1:19196`;
      // WS_API = WS_API.replace('backend', 'socket');
      this.axios
        .get(WS_API + '/OpenDevice', {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(
          function (res) {
            if (res.data.resultFlag === 0) {
              this.axios
                .get(WS_API + '/readcard', {
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                })
                .then(
                  function (res) {
                    if (res.data.certNumber) {
                      this.input = res.data.certNumber;
                      this.toSearch();
                    }
                    //控制台打印请求成功时返回的数据
                    //bind(this)可以不用
                  }.bind(this)
                )
                .catch(
                  function (err) {
                    if (err.response) {
                      clearInterval(this.timeDate);
                      console.log(err.response);
                      //控制台打印错误返回的内容
                    }
                    //bind(this)可以不用
                  }.bind(this)
                );
            } else {
              console.log('请先连接设备！');
            }
            //控制台打印请求成功时返回的数据
            //bind(this)可以不用
          }.bind(this)
        )
        .catch(
          function (err) {
            if (err.response) {
              console.log(err.response);
              //控制台打印错误返回的内容
            }
            //bind(this)可以不用
          }.bind(this)
        );
    },
    init() {
      this.timeDate = setInterval(this.connect, 3000);
    },
    toHandleSearch() {
      this.isShow = false;
      this.isFlag = true;
    },
    toAutomaticSearch() {
      this.isShow = false;
      this.isFlag = false;
      this.init();
    },
    toHandle() {
      this.isFlag = true;
      this.input = '';
      clearInterval(this.timeDate);
    },
    toAutomatic() {
      this.isFlag = false;
      this.input = '';
      this.init();
    }
  },
  created() {
    const token = sessionStorage.getItem('token');
    const sessionId = sessionStorage.getItem('session');
    this.projectId = getSession('projectId');
    this.isSmsVerify = getSession('isSmsVerify');
  },
  mounted() { },
  beforeDestroy() {
    clearInterval(this.timeDate);
  }
};
</script>
<style>
.personal-content-left, .personal-content-right {
  display: inline-block;
  vertical-align: top;
}
.personal {
  height: 100%;
}
.personal-box {
  height: 100%;
  background: #ffffff;
}
.search-content {
  overflow: auto;
  height: calc(100% - 41px);
}
.bbbbbbbbbbbbbb {
  height: calc(100% - 41px);
}
.personal-content {
  overflow: auto;
  height: 100%;
}
.personal-system-header {
  height: 40px;
  border-bottom: 1px solid rgb(2, 91, 145);
}
.personal-system-left {
  float: left;
  padding: 5px 0;
  text-indent: 15px;
  color: #025b91;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
}
.personal-system-right {
  float: right;
  display: flex;
}
.personal-left {
  padding: 5px 150px;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #1e1e1e;
}
.personal-right {
  height: 30px;
  background: inherit;
  background-color: rgba(2, 91, 145, 1);
  border: none;
  border-top: 0px;
  border-radius: 10px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.personal-header,
.search-header {
  text-align: center;
  color: #333333;
  font-size: 28px;
  padding-top: 20px;
}
.search-header {
  padding: 5% 0px;
}
.search-content-detail {
  /* display: flex; */
  /* margin: auto; */
  /* width: 60%; */
  text-align: center;
  /* float: left; */
}
.search-content-detail-left,
.search-content-detail-right {
  cursor: pointer;
  width: 350px;
  height: 150px;
  box-sizing: border-box;
  border-width: 2px;
  border-style: solid;
  border-color: rgba(2, 91, 145, 1);
  border-radius: 10px;
  display: inline-block;
  vertical-align: top;
  padding: 35px 30px;
  box-sizing: border-box;
}
.search-content-detail-img {
  width: 80px;
  float: left;
}
.search-content-detail-img img {
  width: 80px;
  height: 80px;
}
.search-content-detail-right {
  margin-left: 50px;
}
.search-content-detail-title {
  float: left;
  font-size: 28px;
  color: #025b91;
  padding-left: 20px;
  line-height: 70px;
}
.personal-content-box {
  text-align: center;
}
.personal-content-img img {
  width: 200px;
}
.personal-content-right {
  /* padding-left: 70px; */
  padding-top: 30px;
}
.el-input__inner:focus {
  border-color: #025b91 !important;
  box-shadow: none;
  transition-duration: 0.5s;
}
.personal-content-btn {
  cursor: pointer;
  width: 140px;
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-width: 1px;
  border-style: solid;
  border-color: rgba(2, 91, 145, 1);
  border-radius: 5px;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #025b91;
  text-align: center;
  line-height: 40px;
  margin-bottom: 15px;
}
.personal-content-title {
  padding-bottom: 5px;
}
.personal-content-top {
  display: flex;
  flex-wrap: wrap;
}

.personal-content-input {
  padding-bottom: 5px;
}
.bottom-left-top {
  display: flex;
}
.bottom-left-bottom {
  display: flex;
}
.phone-check-content {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  height: calc(100% - 53px);
}
.phone-check-one {
  padding-bottom: 10px;
}
.phone-check-btn {
  display: flex;
  margin-top: 10px;
}
.phone-btn-left {
  cursor: pointer;
  width: 80px;
  height: 40px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(204, 204, 204, 1);
  border-radius: 5px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #666666;
}
.phone-btn-left:hover {
  background: rgb(230, 239, 244);
}
.phone-btn-right,
.make-determine-btn {
  width: 80px;
  height: 40px;
  background-color: rgba(2, 91, 145, 1);
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.ml-8 {
  margin-left: 8px;
}
.phone-btn-right,
.make-determine-btn:hover {
  background: rgb(53, 124, 167);
}
.phone-btn-right:hover {
  background: rgb(53, 124, 167);
}
.verification-code-text {
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #333333;
}
.verification-code-phone {
  color: #333333;
  padding-bottom: 12px;
}
.display {
  display: flex;
}
.make-determine {
  margin-top: 10px;
}
</style>
<style lang="less">
.send-again {
  margin-left: 10px;
  .el-button .is-disabled {
    color: #333333 !important;
  }
  .el-button {
    color: #333333 !important;
    background-color: #ffffff;
    border-color: #dcdfe6;
  }
  .el-button:hover {
    color: #333333 !important;
    background-color: #ffffff;
    border-color: #dcdfe6;
  }
  .el-button:focus {
    color: #333333 !important;
    background-color: #ffffff;
    border-color: #dcdfe6;
  }
  .el-button .is-disabled:hover {
    color: #333333 !important;
  }
}
.personal-content-input {
  .el-input__inner {
    font-size: 18px !important;
  }
}
</style>
<style media="screen" lang="less">
/*分辨率低于1400，采用下面的样式*/
@media screen and (max-device-width: 1680px) {
  .personal-content-img {
    padding: 125px 200px 100px 0;
  }
  .personal-content-input {
    width: 218px;
  }
  .personal-content-btn {
    margin-left: 77px;
  }
  .personal-content-keyBox {
    width: 220px;
  }
  .personal-content-bottom {
    display: flex;
    height: 92px;
    margin-top: 10px;
  }
  .personal-content-x {
    cursor: pointer;
    width: 45px;
    height: 40px;
    background: rgba(242, 242, 242, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-size: 24px;
    margin-top: 10px;
    margin-left: 10px;
  }
  .personal-content-zero {
    cursor: pointer;
    width: 102px;
    height: 40px;
    background: rgba(242, 242, 242, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-size: 24px;
    margin-top: 10px;
  }
  .bottom-right-one {
    cursor: pointer;
    height: 100%;
    width: 45px;
    background: rgba(242, 242, 242, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
  }
  .personal-content-one {
    cursor: pointer;
    width: 45px;
    height: 40px;
    background: rgba(242, 242, 242, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-size: 24px;
  }
  .personal-content-one:nth-child(2),
  .personal-content-one:nth-child(3),
  .personal-content-one:nth-child(4),
  .personal-content-one:nth-child(6),
  .personal-content-one:nth-child(7),
  .personal-content-one:nth-child(8),
  .personal-content-one:nth-child(9) {
    margin-left: 10px;
  }
  .personal-content-one:nth-child(4) img {
    width: 30px;
  }
  .personal-content-one:nth-child(6),
  .personal-content-one:nth-child(7),
  .personal-content-one:nth-child(8),
  .personal-content-one:nth-child(9),
  .personal-content-one:nth-child(11) {
    margin-top: 10px;
  }
  .personal-content-one:nth-child(5) {
    margin-top: 10px;
  }
  .personal-content-one:nth-child(8) {
    font-size: 16px;
  }
}
/*分辨率高于1440，采用下面的样式*/
@media screen and (min-device-width: 1680px) {
  .personal-content-img {
    padding: 200px 200px 100px 0;
  }
  .personal-content-input {
    width: 300px;
  }
  .personal-content-btn {
    margin-left: 156px;
  }
  .personal-content-keyBox {
    width: 300px;
  }
  .personal-content-bottom {
    display: flex;
    height: 130px;
    margin-top: 10px;
  }
  .personal-content-x {
    cursor: pointer;
    width: 65px;
    height: 60px;
    background: rgba(242, 242, 242, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-size: 36px;
    margin-top: 10px;
    margin-left: 10px;
  }
  .personal-content-zero {
    cursor: pointer;
    width: 142px;
    height: 60px;
    background: rgba(242, 242, 242, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-size: 36px;
    margin-top: 10px;
  }
  .bottom-right-one {
    cursor: pointer;
    height: 100%;
    width: 65px;
    background: rgba(242, 242, 242, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
  }
  .personal-content-one {
    cursor: pointer;
    width: 65px;
    height: 60px;
    background: rgba(242, 242, 242, 1);
    border: 1px solid rgba(204, 204, 204, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333333;
    font-size: 36px;
  }
  .personal-content-one:nth-child(2),
  .personal-content-one:nth-child(3),
  .personal-content-one:nth-child(4),
  .personal-content-one:nth-child(6),
  .personal-content-one:nth-child(7),
  .personal-content-one:nth-child(8),
  .personal-content-one:nth-child(9) {
    margin-left: 10px;
  }
  .personal-content-one:nth-child(4) img {
    width: 40px;
  }
  .personal-content-one:nth-child(6),
  .personal-content-one:nth-child(7),
  .personal-content-one:nth-child(8),
  .personal-content-one:nth-child(9),
  .personal-content-one:nth-child(11) {
    margin-top: 10px;
  }
  .personal-content-one:nth-child(5) {
    margin-top: 10px;
  }
  .personal-content-one:nth-child(8) {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/components/validator.vue